var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129.976,
    height: 44,
    viewBox: "0 0 129.976 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App_Store",
    "data-name": "App Store",
    transform: "translate(0 0.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "background",
    d: "M4.28,0H123.7a5.284,5.284,0,0,1,5.28,5.28V38.72A5.284,5.284,0,0,1,123.7,44H4.28A5.284,5.284,0,0,1-1,38.72V5.28A5.284,5.284,0,0,1,4.28,0Z",
    transform: "translate(1 -0.69)",
    fill: "#1f1f1f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_59189",
    "data-name": "Group 59189",
    transform: "translate(10 6.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    d: "M16.9,75.511a5.674,5.674,0,0,1,2.693-4.752,5.836,5.836,0,0,0-4.567-2.473c-1.918-.2-3.784,1.153-4.761,1.153-.994,0-2.508-1.126-4.127-1.1a6.068,6.068,0,0,0-5.113,3.124c-2.209,3.828-.563,9.46,1.558,12.558,1.065,1.514,2.3,3.212,3.925,3.15,1.584-.062,2.182-1.012,4.092-1.012s2.455,1.012,4.11.977c1.707-.026,2.772-1.522,3.8-3.054a12.413,12.413,0,0,0,1.734-3.538A5.488,5.488,0,0,1,16.9,75.511",
    transform: "translate(0.023 -62.258)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M118.122,4A5.583,5.583,0,0,0,119.4,0a5.661,5.661,0,0,0-3.67,1.9,5.354,5.354,0,0,0-1.311,3.846A4.69,4.69,0,0,0,118.122,4",
    transform: "translate(-104.322)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_59188",
    "data-name": "Group 59188",
    transform: "translate(27.45 -0.458)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u0645\\u062F\\u064A\\u0631_\\u0627\\u0644\\u062A\\u0637\\u0628\\u064A\\u0642\\u0627\\u062A",
    "data-name": "\\u0645\\u062F\\u064A\\u0631 \\u0627\\u0644\\u062A\\u0637\\u0628\\u064A\\u0642\\u0627\\u062A",
    transform: "translate(83 27)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "IBMPlexSansArabic-SemiBold, IBM Plex Sans Arabic",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -69.348,
    y: 0
  }, "\u0645\u062F\u064A\u0631 \u0627\u0644\u062A\u0637\u0628\u064A\u0642\u0627\u062A")), /*#__PURE__*/React.createElement("text", {
    id: "\\u0627\\u062D\\u0635\\u0644_\\u0639\\u0644\\u064A\\u0647",
    "data-name": "\\u0627\\u062D\\u0635\\u0644 \\u0639\\u0644\\u064A\\u0647",
    transform: "translate(83 10)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "IBMPlexSansArabic-Regular, IBM Plex Sans Arabic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -42.37,
    y: 0
  }, "\u0627\u062D\u0635\u0644 \u0639\u0644\u064A\u0647")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.cb65db663b941306cc28ec90ab257aa9.svg";
export { ForwardRef as ReactComponent };